module.exports = __webpack_public_path__ + "defdface72e9a2fdbc9cc223ba3c6c14.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-24.png
// module id = 2704
// module chunks = 0